(() => {
  function init(root = document) {
    root.querySelectorAll('[data-cf-hotspot]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = '1';
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') === 'true';
        button.closest('.cf-material__media').querySelectorAll('[data-cf-hotspot]').forEach(i => i.setAttribute('aria-expanded', 'false'));
        button.setAttribute('aria-expanded', String(!open));
      });
    });
  }
  addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
